export const CleanStatusTypeConst = {
  PaymentPending: '未付款',
  Reserved: '已預約',
  Cleaning: '清潔中',
  Cleaned: '已清潔',
  Rated: '已評價',
  TimedOut: '已逾期',
  Canceled: '已取消',
} as const;

export const nonCleanItemKeys = [
  'phoneNumber',
  'cleanKind',
  'communityAndHouseholdNumber',
  'date',
];
